import Icon from 'components/Icon'
import React from 'react'
import styled from 'styled-components'
import { colors, _ } from 'utils'
import { StatusOverview } from '../tabs/Attendees'

const S = {
    Wrapper: styled.div`
        margin: -41px -20px 20px -20px;
    `,
    NotificationBar: styled.div`
        display: flex;
        align-items: center;
        padding: 11px 23px;
        background-color: ${colors.primaryOpacity(0.05)};
        font-size: 14px;
        color: ${colors.grayTitle};
    `,
    OverviewStatus: styled.div`
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        height: 84px;
        padding: 12px 0;
        background-color: ${colors.primaryOpacity(0.02)};
        border-top: 1px solid ${colors.statusBorder};
        border-bottom: 1px solid ${colors.statusBorder};
        & > div:last-child {
            border-right: none;
        }
    `,
    OverviewItem: styled.div`
        height: 100%;
        min-width: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-right: 1px solid ${colors.statusBorder};
        & > h3 {
            margin-bottom: 0;
            font-size: 14px;
            font-weight: 500;
            color: ${colors.icon};
            text-transform: uppercase;
        }
        & > span {
            font-size: 20px;
            color: ${colors.dark};
        }
    `,
}

const OverviewItem = ({ title, value }: { title: string, value: number }) => (
    <S.OverviewItem>
        <h3>
            {title}
        </h3>
        <span>
            {value}
        </span>
    </S.OverviewItem>
)

const AttendeesOverview = ({
    statusOverview, reachedLimit
}: { statusOverview: StatusOverview, reachedLimit?: boolean }) => {
    const total = statusOverview.accepted + statusOverview.new + statusOverview.pending
    return (
        <S.Wrapper>
            {reachedLimit && (
                <S.NotificationBar>
                    <Icon
                        icon="info"
                        color={colors.primaryOpacity(0.75)}
                        className="mb-3px mr-2"
                        size={18}
                    />
                    {_('attendee.list.max_limit_reached')}
                </S.NotificationBar>
            )}
            <S.OverviewStatus>
                <OverviewItem title={_('attendee.overview_status.total')} value={total} />
                <OverviewItem title={_('attendee.overview_status.new')} value={statusOverview.new} />
                <OverviewItem title={_('attendee.overview_status.pending')} value={statusOverview.pending} />
                <OverviewItem
                    title={_('attendee.overview_status.accepted')}
                    value={statusOverview.accepted}
                />
            </S.OverviewStatus>
        </S.Wrapper>
    )
}

export default AttendeesOverview
